module.exports = __webpack_public_path__ + "static/media/gifts.55d89c42.svg";